import React, { useState } from 'react';
import PropertiesService from '../../Services/PropertiesService';
import { toast } from 'react-toastify';
import DocumentUploadForm from '../DocumentUploadForm/DocumentUploadForm';

const DateFormate = () => {
    const [fileInputs, setFileInputs] = useState({
        date: [{ id: 'input-1', data: null }]
    });
    const [formatType, setFormatType] = useState('');
    const handleClick = (inputRef) => {
        if (inputRef) inputRef.click();
    };
    const handleFileUpload = async (e, category, id) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('image', file);
        try {
            const response = await PropertiesService.UploadFiles(formData);
            const data = response.Location;
            setFileInputs((prev) => ({
                ...prev,
                [category]: prev[category].map((input) =>
                    input.id === id ? { ...input, data } : input
                )
            }));
        } catch (error) {
            toast.error('File upload failed');
        }
    };
    const addFileInput = (category) => {
        const newInput = { id: `input-${fileInputs[category].length + 1}`, data: null };
        setFileInputs((prev) => ({
            ...prev,
            [category]: [...prev[category], newInput]
        }));
    };
    const removeFileInput = (category, id) => {
        if (fileInputs[category].length > 1) {
            setFileInputs((prev) => ({
                ...prev,
                [category]: prev[category].filter((input) => input.id !== id)
            }));
        }
    };
    return (
        <div className="step-content">
            <DocumentUploadForm
                category="date"
                files={fileInputs["date"]}
                handleClick={handleClick}
                handleFileUpload={handleFileUpload}
                addFileInput={() => addFileInput("date")}
                removeFileInput={(id) => removeFileInput("date", id)}
                formatType={formatType}
            />
        </div>
    );
}

export default DateFormate;
